import { c as _c } from "react/compiler-runtime";
import { Autocomplete } from '@base-ui/react/autocomplete';
import type { ReactNode, RefObject } from 'react';
type SearchPopupProps = {
  anchorRef: RefObject<HTMLDivElement | null>;
  children?: ReactNode;
  isFullscreen: boolean;
  portalContainer: HTMLElement;
};
export function SearchPopup(t0) {
  const $ = _c(11);
  const {
    anchorRef,
    children,
    isFullscreen,
    portalContainer
  } = t0;
  const t1 = isFullscreen ? portalContainer : anchorRef;
  const t2 = isFullscreen ? "fixed" : "absolute";
  const t3 = isFullscreen ? 0 : 1;
  const t4 = isFullscreen ? "header-search__positioner header-search__positioner--fullscreen" : "header-search__positioner";
  let t5;
  if ($[0] !== children) {
    t5 = <Autocomplete.Popup className="header-search__popup">{children}</Autocomplete.Popup>;
    $[0] = children;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3 || $[5] !== t4 || $[6] !== t5) {
    t6 = <Autocomplete.Positioner align="start" anchor={t1} collisionPadding={0} positionMethod={t2} side="bottom" sideOffset={t3} className={t4}>{t5}</Autocomplete.Positioner>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== portalContainer || $[9] !== t6) {
    t7 = <Autocomplete.Portal container={portalContainer}>{t6}</Autocomplete.Portal>;
    $[8] = portalContainer;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}